<div class="dynamic-input-container">
  <div *ngFor="let input of inputs; let i = index; trackBy: trackByFn" class="input-row">
    <!-- Hiển thị index trước input -->
    <span class="input-index">{{ i + 1 }}. </span> <!-- Hiển thị index -->
    <input matInput [(ngModel)]="inputs[i].value" [placeholder]="placeholder" (ngModelChange)="updateInput(i, $event)"
      name="input-{{ input.key }}" class="input-style" />
    <button mat-icon-button color="warn" *ngIf="inputs.length > 1" (click)="removeInput(i)">
      <i class="fa-solid fa-trash" style="color: #f05a2d;"></i>
    </button>
  </div>
  <button mat-raised-button type="button" (click)="addInput()" style="max-width: fit-content;">
    <i class="material-icons" style=" color:#FFC200">add</i> 
    <span style="color: #FFC200;font-weight: 400;">Thêm lựa chọn</span>
  </button>
</div>
